module.exports = __webpack_public_path__ + "img/parking-lots-bg.6003aaf3.jpg";